import { createSlice } from '@reduxjs/toolkit';
import { IAuthState } from '../../interfaces';
import { authAction } from '../actions';
import { authReducer as extraReducers } from '../reducers';

const initialState: IAuthState = {
  status: 'inactive',
  userProfile: null,
  accessToken: null,
  error: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  // Non-async reducers
  reducers: {
    resetAuth: () => {
      return initialState;
    },
  },
  // Async reducers
  extraReducers,
});

// Action creators are generated for each case reducer function
export const authSliceActions = { ...authSlice.actions, ...authAction };

export default authSlice.reducer;
